"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContextDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.PageContextDefinition = (0, static_service_1.defineStaticService)('viewer-core/viewer-service-page-context');
//# sourceMappingURL=index.js.map